import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Handlebars from 'handlebars';
import { SeoData } from "../models/builderIO/types";

const CommonSeo: React.FC<{ seoCommon: SeoData, content: any, templateData: any }> = ({ seoCommon, content, templateData }) => {
  useEffect(() => {
    const metaTag = document.querySelector("meta[name='description']");
    if (metaTag && metaTag.parentNode) {
      metaTag.parentNode.removeChild(metaTag);
    }
  }, []);

  const generatePlaceholderMap = (obj: any, parentKey: string = ''): Record<string, any> => {
    const result: Record<string, any> = {};

    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      if (value != null && typeof value === 'object' && !Array.isArray(value)) {
        Object.assign(result, generatePlaceholderMap(value, newKey));
      } else {
        result[newKey] = value;
      }
    });

    return result;
  };

  const placeholders = generatePlaceholderMap(templateData);

  const renderTemplate = (template: string) => {
    return Handlebars.compile(template)(templateData);
  };

  const finalName = renderTemplate(seoCommon.name || '');
  const finalOgImage = renderTemplate(seoCommon.ogimage || '');
  const finalTitle = renderTemplate(seoCommon.title || '');
  const finalDescription = renderTemplate(seoCommon.description || '');
  const lansingNow = 'Lansing Building Products';
  const pageUrl = window.location.href;
  
  /*
  const jsonLD = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": `${finalName}`,
    "image": finalOgImage,
    "url": pageUrl,
    "telephone": renderTemplate(seoCommon.telephone || ''),
    "address": {
      "@type": "PostalAddress",
      "streetAddress": renderTemplate(seoCommon.streetAddress || ''),
      "addressLocality": renderTemplate(seoCommon.addressLocality || ''),
      "addressRegion": renderTemplate(seoCommon.addressRegion || ''),
      "postalCode": renderTemplate(seoCommon.postalCode || ''),
      "addressCountry": renderTemplate(seoCommon.addressCountry || '')
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": renderTemplate(seoCommon.latitude || ''),
      "longitude": renderTemplate(seoCommon.longitude || '')
    },
    "hasMap": `https://www.google.com/maps?q=${renderTemplate(seoCommon.latitude || '')},${renderTemplate(seoCommon.longitude || '')}`,
    "openingHours": renderTemplate(seoCommon.openingHours || ''),
    "sameAs": [
      renderTemplate(seoCommon.facebook || ''),
      renderTemplate(seoCommon.linkedin || '')
    ],
    "branchOf": {
      "@type": "Organization",
      "name": "Lansing Building Products",
      "url": "https://www.lansingbp.com",
      "sameAs": [
        renderTemplate(seoCommon.facebook || ''),
        renderTemplate(seoCommon.linkedin || '')
      ]
    }
  };
  */

  return (
    <>
      <Helmet>
        <title>{finalTitle || content.data.title}</title>
        <meta name="description" content={finalDescription || content.data.description} />
        <meta name="keywords" content={seoCommon.keywords || ''} />
        <meta name="author" content={seoCommon.author || lansingNow} />
        <meta name="publisher" content={seoCommon.publisher || lansingNow} />
        <meta name="copyright" content={seoCommon.copyright || '© ' + lansingNow} />
        <meta property="og:title" content={finalTitle || content.data.title} />
        <meta property="og:description" content={finalDescription || content.data.description} />
        <meta property="og:url" content={seoCommon.ogurl || pageUrl} />
        <meta property="og:type" content={seoCommon.ogtype || 'website'} />
        <meta property="og:site_name" content={seoCommon.ogsitename || lansingNow} />
        <meta property="og:image" content={finalOgImage} />
        <link rel="canonical" href={pageUrl} />
        {/* {jsonLD && (
          <script type="application/ld+json">
            {JSON.stringify(jsonLD)}
          </script>
        )} */}
      </Helmet>
    </>
  );
};

export default CommonSeo;
